const ENProgram = {
	"Adicionar Programa": "Add Program",
	"Alterar Programa": "Change Program",
	"Deseja realmente excluir o programa": "Do you really want to delete the program",
	"Digite o título do programa para excluí-lo": "Enter the title of the program to delete it",
	"Editar Programa": "Edit Program",
	"Erro ao adicionar programa": "Error adding program",
	"Erro ao alterar programa": "Error changing program",
	"Erro ao excluir programa": "Error deleting program",
	"Excluir Programa": "Delete Program",
	"Exclusão do Programa": "Exclusion from the Program",
	"Programas": "Programs",
	"Programa adicionado com sucesso": "Program successfully added",
	"Programa alterado com sucesso": "Program successfully changed",
	"Programa excluído com sucesso": "Program deleted successfully",
	"Título do programa não confere": "Program title does not match"
};

export default ENProgram;
